import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
export default function useBannerList() {
    
    const isBannerFormSidebarActive = ref(false)
    const isBannerUploadSidebarActive = ref(false)

    const bannerData = ref(null);
    
    const toast = useToast()
    const refBannerListTable = ref(null);
    const tableColumns = [
        
        { key: 'title', label: 'Title', sortable: false },
        { key: 'slug', label: 'Slug', sortable: false },


        { key: 'action', label: '#', sortable: false },


    ]
    const perPage = ref(10)
    const totalBanners= ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)
    const statusFilter = ref(null)
    const getLocalSite = JSON.parse(localStorage.getItem('site'))
    const dataMeta = computed(() => {
        const localItemsCount = refBannerListTable.value ? refBannerListTable.value.localItems.length : 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalBanners.value,
        }
    })
    
    const refetchData = () => {
        refBannerListTable.value.refresh()
    }
    watch([currentPage, perPage, searchQuery, statusFilter], () => {
        refetchData()
    })
    const fetchData = (ctx, callback) => {
        const offset = perPage.value*(currentPage.value-1);
       
        store
          .dispatch('app-banner/fetchData', {
            limit: perPage.value,
            offset:offset,
            keywords: searchQuery.value,
            sites_id: getLocalSite.id,
          })
          .then(response => {
           
            const  cats  = response.data.data
            
            const total = response.data.total?response.data.total:cats.length;
            callback(cats)
            totalBanners.value = total
          })
          .catch(() => {
            toast({
              component: ToastificationContent,
              props: {
                title: "Error fetching Category' list",
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          })
    }
    const resolveCatStatusVariant = status => {
       
        if (status) return 'success'
        if (!status ) return 'secondary'
        return 'primary'
    }
    const resolveCatStatusnameVariant = status => {
        if (status) return 'Active'
        if (!status) return 'Inactive'
        return 'primary'
    }
    const updateData = (data)=>{

        bannerData.value = data;
        isBannerFormSidebarActive.value = true;
    }
    const updateUpload = (data)=>{
        bannerData.value = data;
        isBannerUploadSidebarActive.value = true;

    }
    const deleteData = (id) => {
        //fetchDeleteProperty
        store.dispatch('app-banner/deleteData',id).then(response=>{
          toast({
            component: ToastificationContent,
            props: {
              title: "Delete Success",
              icon: 'AlertTriangleIcon',
              variant: 'success',
            },
          })
          refetchData();
        }).catch(()=>{
          toast({
            component: ToastificationContent,
            props: {
              title: "Error Delete Banner",
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
    
        })
        //console.log('id', id);
        
      }
      
    return {
        isBannerFormSidebarActive,
        isBannerUploadSidebarActive,
        bannerData,
        refBannerListTable,
        tableColumns,
        perPage,
        totalBanners,
        currentPage,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        statusFilter,
        dataMeta,
        refetchData,
        fetchData,
        resolveCatStatusVariant,
        resolveCatStatusnameVariant,
        updateData,
        updateUpload,
        deleteData
    

    }
}